'use client';

import { GlobalOutlined } from '@ant-design/icons';
import { Select } from 'antd';
import type { Route } from 'next';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useMemo } from 'react';

type SupportedLocale = 'vi' | 'en';

export type LocaleSwitcherLabels = {
  label: string;
  vietnamese: string;
  english: string;
};

type Option = {
  value: SupportedLocale;
  label: string;
};

type LocaleSwitcherProps = {
  locale: SupportedLocale;
  labels: LocaleSwitcherLabels;
};

export function LocaleSwitcher({ locale, labels }: LocaleSwitcherProps) {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const options = useMemo<Option[]>(
    () => [
      { value: 'vi', label: labels.vietnamese },
      { value: 'en', label: labels.english }
    ],
    [labels.english, labels.vietnamese]
  );

  return (
    <div className="flex items-center gap-2">
      <GlobalOutlined className="text-slate-500" />
      <Select
        size="small"
        value={locale}
        aria-label={labels.label}
        options={options}
        style={{ width: 160 }}
        onChange={(nextLocale) => {
          const params = new URLSearchParams(searchParams.toString());
          params.set('locale', nextLocale);
          const query = params.toString();
          const nextHref = (query ? `${pathname}?${query}` : pathname) as Route;
          router.push(nextHref);
        }}
      />
    </div>
  );
}

